import React from 'react';
import { motion } from 'framer-motion';
export function ImagineSection() {
  return <section className="py-20 px-4 bg-[#0B1A2E]" data-id="element-173">
      <div className="max-w-3xl mx-auto text-center" data-id="element-174">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-4xl font-bold text-white mb-8 leading-tight" data-id="element-175">
          Imaginá tu estudio contable con todo esto resuelto
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-base md:text-lg text-slate-300 leading-relaxed mb-10 max-w-2xl mx-auto" data-id="element-176">
          Gestionás tus clientes con claridad. Sabés exactamente qué tareas
          tenés pendientes y qué vencimientos se acercan. No improvisás. No
          perdés tiempo buscando información entre archivos, carpetas o
          mensajes.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="rounded-full px-8 py-3 md:px-10 md:py-4 inline-block mx-auto" style={{
        background: 'rgba(15,23,42,0.7)',
        border: '1.5px solid rgba(34,197,94,0.5)',
        boxShadow: '0 0 15px rgba(34,197,94,0.1)'
      }} data-id="element-177">
          <p className="text-base md:text-xl text-green-400 font-bold tracking-wide uppercase text-center" data-id="element-178">
            Terminás tu jornada con todo bajo control y sin estrés.
          </p>
        </motion.div>
      </div>
    </section>;
}